import "babel-polyfill";
import "../styles/application.styl";

import api from "./api";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { Router } from "react-router-dom";
import history from "./history";
import App from "./containers/App";

import Raven from "raven-js";
import storage from "local-storage-fallback";
if (!("localStorage" in window)) {
  window.localStorage = storage;
}

// set up redux and router
import createStore from "./store";
const store = createStore(api);

// init parts
import Registry from "./registry";
import "./parts/text";
import "./parts/textarea";
import "./parts/number";
import "./parts/date";
import "./parts/hidden";
import "./parts/color";
import "./parts/select";
import "./parts/checkbox";
import "./parts/radio";
import "./parts/content";
import "./parts/file";
import "./parts/image";
import "./parts/toggle";
import "./parts/relationship";
import "./parts/collection";
import "./parts/slug";
import "./parts/url";
import "./parts/list";
import "./parts/json";

import t from "tcomb-form/lib";
import * as fieldTemplates from "./lib/fieldTemplates";
t.form.Form.templates = fieldTemplates;

// let us know we have js
document.documentElement.className = document.documentElement.className.replace(
  "no-js",
  "js"
);

// init
ReactDOM.render(
  <Provider store={store}>
    <Router history={history}>
      <App />
    </Router>
  </Provider>,
  document.getElementById("app")
);

// error reporting
Raven.config(
  "https://8db6c8f2b27344c2be63d3ec3883c027@errors.ripeworks.com/3",
  {
    whitelistUrls: [/fridgecms\.com/, /\*\.fridgecms\.com/],
  }
).install();



// WEBPACK FOOTER //
// ./app/app.js